<template>
  <rv-tri-radio :name="name" :label="label" :option-a="'Ingoing Fee'" :option-b="'Resale Value'" :option-c="'Higher of the Two'" v-model="data" v-on:input="update">
    <span slot="option-a">
      Ingoing/Entry Fee
    </span>
    <span slot="option-b">
      Resale Value
    </span>
    <span slot="option-c">
      Higher of the Two
    </span>
  </rv-tri-radio>
</template>

<script>
import RvTriRadio from '../RvTriRadio'

export default {
  props: ['value'],
  components: {
    RvTriRadio
  },
  data() {
    return {
      label: 'Is the exit fee based on YOUR ingoing payment, on the ingoing payment by the NEXT resident (resale value), or the higher of the two?',
      name: 'outgoing-fee-type',
      data: this.value
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modules/inputs/outgoing-fees/OutgoingFeeType.vue